import { render, staticRenderFns } from "./detail-comment.vue?vue&type=template&id=5bc57c90&scoped=true"
import script from "./detail-comment.vue?vue&type=script&lang=js"
export * from "./detail-comment.vue?vue&type=script&lang=js"
import style0 from "./detail-comment.vue?vue&type=style&index=0&id=5bc57c90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc57c90",
  null
  
)

export default component.exports